import axios from '@/libs/api.request'
// 获取案例分享列表
export const getDetailsInfo = (params) => {
    return axios.request({
        url: `track/${params.id}`,
        method: 'get'
    })
}
